import { render, staticRenderFns } from "./formInputs.vue?vue&type=template&id=db5b8070&scoped=true&"
import script from "./formInputs.vue?vue&type=script&lang=js&"
export * from "./formInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5b8070",
  null
  
)

export default component.exports